/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_TitleInputs */



/**
* | output |
* | --- |
* | "External Device Control" |
*
* @param {Creator_Ext_Device_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_title = /** @type {((inputs?: Creator_Ext_Device_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Controle des appareils externes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Steuerung externer Geräte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controllo del dispositivo esterno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление внешним устройством")
	if (locale === "es") return /** @type {LocalizedString} */ ("Control de dispositivos externos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("外部设备控制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("外部デバイス制御")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाह्य उपकरण नियंत्रण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controle de Dispositivo Externo")
	return /** @type {LocalizedString} */ ("External Device Control")
});